import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

function BackToTopButton() {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 200);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        showButton && (
            <button
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: '60px',
                    right: '60px',
                    padding: '14px',
                    fontSize: '18px',
                    color: '#fff',
                    backgroundColor: '#0062a1',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
                }}
                aria-label="Back to top"
            >
                <FontAwesomeIcon icon={faChevronUp} />
            </button>
        )
    );
}

export default BackToTopButton;
